import type { CSSProperties } from 'react';

// Skeleton-loading primitives (CLAUDE.md: skeleton loading is part of the shell).
// The `.skeleton` shimmer is defined in theme.css. Duplicated per surface (CB-D3).
export function Skeleton({
  width,
  height,
  radius = 8,
  style,
}: {
  width?: number | string;
  height?: number | string;
  radius?: number;
  style?: CSSProperties;
}) {
  return (
    <span
      className="skeleton"
      aria-hidden="true"
      style={{ display: 'block', width: width ?? '100%', height: height ?? 16, borderRadius: radius, ...style }}
    />
  );
}

// A stack of row-shaped skeletons for the admin tables/lists while data loads.
export function ListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div aria-busy="true" aria-label="Loading" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card" style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
          <Skeleton width="40%" height={15} />
          <Skeleton width="72%" height={12} />
          <Skeleton width="28%" height={12} />
        </div>
      ))}
    </div>
  );
}
